import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=9b54abe6"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformation.vue?vue&type=style&index=0&id=9b54abe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports